import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stringSorter } from "../../utils/functions.js";
import DataTable from "../../components/CustomDatatable/index.js";
import {
  Button,
  Card,
  Space,
  Typography,
  Breadcrumb,
  Row,
  Col,
  Popconfirm,
  Switch,
  message,
  Modal,
} from "antd";
import { DeleteOutlined, EditOutlined, HomeOutlined, PlusOutlined } from "@ant-design/icons";
import { Spinner } from "reactstrap";
import GlobalBillCodeForm from "./GlobalBillCodeForm.js";
import { enhanceColumnsWithFilters } from "../../components/ColumnFilters/index.js";
import moment from "moment-timezone";
import { deletePackage } from "../../store/actions/package.js";
import {
  addGlobalBillCode,
  deleteGlobalBillCode,
  getGlobalBillCode,
  updateGlobalBillCode,
  updateGlobalBillCodeStatus,
} from "../../store/actions/globalBillCode.js";

const { Title } = Typography;

const GlobalBillCode = () => {
  document.title = "Global Bill Code";
  const [isLoading, setIsLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const dispatch = useDispatch();
  const globalBillCode = useSelector((state) => state.globalBillCode.list);

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteComfirmModalVisible, setDeleteComfirmModalVisible] =
    useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        await dispatch(getGlobalBillCode());
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, [dispatch]);

  const handleCreate = async (values) => {
    setIsSaving(true);
    try {
      if (selectedRecord) {
        // Prepare the payload for update
        const payload = {
          ...selectedRecord,
          ...values
        };
        await dispatch(updateGlobalBillCode(payload));
      } else {
        // Prepare the payload for creation
        await dispatch(addGlobalBillCode(values));
      }
      // Refresh the list after successful operation
      await dispatch(getGlobalBillCode());
      setIsModalVisible(false);
      setSelectedRecord(null);
    } catch (error) {
      console.error("Error in handleCreate:", error);
    } finally {
      setIsSaving(false);
    }
  };



  // const handleDelete = async (id) => {
  //   await dispatch(deleteGlobalBillCode(id));
  //   await dispatch(getGlobalBillCode());
  // };

  const handleDelete = async (item) => {
    setItemToDelete(item);
    setDeleteModalVisible(true);
  };
  const handleConfirmDelete = async (item) => {
    setItemToDelete(item);
    setDeleteComfirmModalVisible(true);
  };

  const confirmDelete = async () => {
    try {
      await dispatch(deleteGlobalBillCode(itemToDelete.id));
      await dispatch(getGlobalBillCode());
      setDeleteComfirmModalVisible(false);
    } catch (error) {
      message.error("An error occurred while deleting the item");
    }
  };

  const handleChangeStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === 1 ? 0 : 1; // Toggle status
    const updatedData = { id: id, status: newStatus }; // Create an object for update
    await dispatch(updateGlobalBillCodeStatus(updatedData));
    await dispatch(getGlobalBillCode());
  };

  const renderCell = (text) => (text ? text : "N/A");
  let columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: stringSorter("name"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "CODE",
      dataIndex: "code",
      key: "code",
      sorter: stringSorter("code"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "createdu",
      dataIndex: "createdu",
      key: "createdu",
      sorter: stringSorter("createdu"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) =>
        moment(date).isValid()
          ? moment(date).format("YYYY-MM-DD HH:mm:ss")
          : "",
      sorter: (a, b) =>
        moment(a.createdAt).isValid() && moment(b.createdAt).isValid()
          ? moment(a.createdAt).unix() - moment(b.createdAt).unix()
          : 0,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Created By",
      dataIndex: "createdByName",
      key: "createdByName",
      sorter: stringSorter("createdByName"),
      sortDirections: ["ascend", "descend"],
      render: renderCell,
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (date) =>
        moment(date).isValid()
          ? moment(date).format("YYYY-MM-DD HH:mm:ss")
          : "",
      sorter: (a, b) =>
        moment(a.updatedAt).isValid() && moment(b.updatedAt).isValid()
          ? moment(a.updatedAt).unix() - moment(b.updatedAt).unix()
          : 0,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Updated By",
      dataIndex: "updatedByName",
      key: "updatedByName",
      sorter: stringSorter("updatedByName"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <Switch
          checked={text === 1}
          onChange={() => handleChangeStatus(record.id, text)}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setSelectedRecord(record);
              setIsModalVisible(true);
            }}
          >
            <EditOutlined />
          </Button>
          {/* <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm> */}
          {record?.status ? (
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(record)}
            >
              {/* Delete */}
            </Button>
          ) : (
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleConfirmDelete(record)}
            >
              {/* Delete */}
            </Button>
          )}
        </Space>
      ),
    },
  ];
  columns = enhanceColumnsWithFilters(columns);

  return (
    <div className="page-content">
      <Breadcrumb style={{ marginBottom: "16px" }}>
        <Breadcrumb.Item href="/">
          <HomeOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item href="/dashboard">Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Global Bill Code</Breadcrumb.Item>
      </Breadcrumb>

      <Card>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Row justify="space-between" align="middle">
            <Col>
              <Title level={2} style={{ margin: 0 }}>
                Manage Global Bill Code
              </Title>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setSelectedRecord(null);
                  setIsModalVisible(true);
                }}
              >
                Add Global Bill Code
              </Button>
            </Col>
          </Row>
          {isLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <DataTable
              dataSource={globalBillCode.map((item) => ({
                ...item,
                key: item.id,
                status: item.status ? 1 : 0,
              }))}
              columns={columns}
            />
          )}
        </Space>
      </Card>
      <GlobalBillCodeForm
        visible={isModalVisible}
        onCreate={handleCreate}
        onCancel={() => {
          setIsModalVisible(false);
        }}
        record={selectedRecord}
        confirmLoading={isSaving}
        key={selectedRecord?.id || "new"}
      />


      <Modal
        title="Confirm Delete"
        zIndex={100000000}
        visible={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setDeleteModalVisible(false)}>
            Ok
          </Button>,
          // <Button key="delete" danger onClick={confirmDelete}>
          //   Delete
          // </Button>,
        ]}
      >
        <p>Can not remove active GlobalBillCode</p>
        {itemToDelete && (
          <p>
            <strong>Record Name:</strong> {itemToDelete.name}
          </p>
        )}
        {/* <p style={{ color: "red" }}>
          <b>Note: </b> Delete Customer will remove all the data including
          database of customer{" "}
        </p> */}
      </Modal>

      <Modal
        title="Delete Customer"
        zIndex={100000000}
        visible={deleteComfirmModalVisible}
        onCancel={() => setDeleteComfirmModalVisible(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => setDeleteComfirmModalVisible(false)}
          >
            Cancel
          </Button>,
          <Button key="delete" danger onClick={confirmDelete}>
            Delete
          </Button>,
        ]}
      >
        <h4>Are you sure you want to delete GlobalBillCode?</h4>
        {itemToDelete && (
          <p>
            <strong>GlobalBillCode:</strong> {itemToDelete.name}
          </p>
        )}
        {/* <p style={{ color: "red" }}>
          <b>Note: </b> Delete Customer will remove all the data including
          database of customer{" "}
        </p> */}
      </Modal>
    </div>
  );
};

export default GlobalBillCode;
